import React, { createContext, useRef, useContext } from 'react';

// Create a context to hold the ref
const MoreGlobalRefContext = createContext(null);

export const MoreGlobalRef = ({ children }) => {
  // Create the ref
  const globalRef:any = useRef(null);

  return (
    <MoreGlobalRefContext.Provider value={globalRef}>
      {children}
    </MoreGlobalRefContext.Provider>
  );
};

// Custom hook to use the global ref
export const useMoreGlobalRef = () => {
  return useContext(MoreGlobalRefContext);
};
